import { Button, CircularProgress, Typography } from "@mui/material";
import { styled } from "@mui/styles";


export const FormContainer = styled("div")(() => ({
    // "& div": {
    // 	background: "#FFFFFF",
    // },
}));

export const ButtonContainer = styled(Button)(() => ({
    color: "#638dff",
}));

export const ButtonProgress = styled(CircularProgress)(() => ({
    // position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: 0,
    marginLeft: 9,
}));

export const SelectedFileText = styled("span")(() => ({
    display: "flex",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: 14,
    fontFamily: 'Roboto, sans-serif',
    color: "#98b0c8",
    alignItems: "center",
    cursor: "pointer",
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: "red",
}));

export const InfoText = styled(Typography)(() => ({
    color: "#aeb8d6",
}));